import React from "react";
import GeneralTable from "../../components/Table/GeneralTable";
import { useTranslation } from "react-i18next";

export default function BreakdownRootCause() {
    const { t } = useTranslation("translation");

    return (
        <div>
            <GeneralTable
                table="BreakdownRootCause"
                resourcePath="GetDetailedList"
                id="brc_gt"
                title={t("BreakdownRootCause")}
                search={t("SearchBreakdownRootCause")}
            />
        </div>
    );
}
